import React from "react";
import {useAppSelector} from "../../../redux/hooks";
import {lessonPlayerStore} from "../../../redux/lesson/LessonPlayerStore";
import {GenericModal} from "components/common/genericModal/GenericModal";
import playbackOrchestrator from "../../../services/playbackOrchestrator/playbackOrchestrator";
import {logger} from "../../../services/log/logger";
import {usePitchDetectionStatus} from "../../../hooks/pitchDetectionStatus.hook";

export default function KeyboardDisconnectedModal() {
  const isMidiConnected = useAppSelector(lessonPlayerStore.getIsMidiConnected);
  const canShowKeyboardDisconnectedModal = useAppSelector(lessonPlayerStore.getCanShowKeyboardDisconnectedModal);
  const segment = useAppSelector(lessonPlayerStore.getSegment);
  const hasVideo = segment?.hasVideo ?? false;

  const {isPitchDetectionEnabled} = usePitchDetectionStatus();

  logger.pitchDetection.info({
    message: "KeyboardDisconnectedModal",
    showDataOnOneLine: false,
    data: [
      { key: "isMidiConnected", value: isMidiConnected },
      { key: "canShowKeyboardDisconnectedModal", value: canShowKeyboardDisconnectedModal },
      { key: "hasVideo", value: hasVideo },
    ]
  });

  if (isMidiConnected || !canShowKeyboardDisconnectedModal || hasVideo) { return null; }

  let message = "Please check the connection between your keyboard and device. ";
  if (isPitchDetectionEnabled) {
    message += "If the keyboard isn't connected, feedback will be provided using your device's microphone.";
  }

  return (
    <GenericModal
      canShow={() => { return true; }} backgroundColor={"white"}
      title={"Keyboard disconnected"}
      onClose={() => {
        lessonPlayerStore.setCanShowKeyboardDisconnectedModal(false);
        playbackOrchestrator.stop(true);
      }}
    >
      {message}
    </GenericModal>
  );
}